import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ClinicActionsCell = ({ clinic }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const goToUsers = () => {
        handleClose();
        navigate('/mgmt/clinic/users', {
            state: { clinic }
        });
    };

    const goToSettings = () => {
        handleClose();
        navigate('/mgmt/clinic/settings', {
            state: { clinic }
        });
    };

    return (
        <>
            <IconButton size="small" onClick={handleOpen}>
                <MoreVertIcon fontSize="small" />
            </IconButton>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={goToUsers}>{t('clinics.users')}</MenuItem>
                <MenuItem onClick={goToSettings}>{t('clinics.settings')}</MenuItem>
            </Menu>
        </>
    );
};

export default ClinicActionsCell;
